import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';

import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { pipe, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { Router } from '@angular/router';
import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { RecipientService } from 'src/app/screens/recipient/services/recipient.service';

type VaccinatedInfoState = {
  loading: boolean;
  error: Error | null;
  benfData: any;
  benfVaccinatedInfo: any[];
};
const initialState: VaccinatedInfoState = {
  loading: false,
  error: null,
  benfData: null,
  benfVaccinatedInfo: [],
};

export const VaccinatedInfoStoreData = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (
      store,
      router = inject(Router),
      encDecService = inject(EncDecService),
      utils = inject(UtilsService),
      recipientService = inject(RecipientService)
    ) => ({
      getVaccinatedInfoByBenf: rxMethod<{ beneficiary_reference_id: number }>(
        pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap((payload: { beneficiary_reference_id: number }) => {
            return recipientService.getUipVaccineByBenRef(payload).pipe(
              tapResponse({
                next: (res: any[]) => {
                  patchState(store, {
                    loading: false,
                    error: null,
                    benfVaccinatedInfo: res,
                  });
                },
                error: (err: Error) => {
                  patchState(store, {
                    loading: false,
                    error: err,
                  });
                },
              })
            );
          })
        )
      ),
      setBeneficiaryData: (benfData: any) => {
        patchState(store, {
          benfData: benfData,
        });
      },
    })
  )
);
